<template>
    <div v-if="isAuthenticated">
        <WidgetsAccountDropdown />
    </div>
    <div v-else>
        <UtilsNotLogin />
    </div>
</template>

<script lang="ts" setup>
const { isAuthenticated } = useSanctumAuth();
</script>

<style></style>
